module.exports = __webpack_public_path__ + "img/abmes-03.981c8dde.png";